import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme, { colors: any }>((theme) => ({
  main: {
    width: '100%',
    minHeight: 141,
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 10px',
    background: (props) => props.colors.colorGradient,
    color: (props) => props.colors.textAccentColor,
  },
  text: {
    textTransform: 'capitalize',
    fontFamily: 'Roboto',
    margin: '0px 15px',
    color: (props) => props.colors.textBody,
    cursor: 'pointer',
  },
  textButton: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontStyle: 'normal',
    marginLeft: '0.3rem',
    fontSize: theme.typography.pxToRem(14),
    color: (props) => props.colors.colorSecondary,
    whiteSpace: 'nowrap',
  },
  textName: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    textTransform: 'capitalize',
    color: (props) => props.colors.accentColor,
  },
  textNamePopOver: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    textTransform: 'capitalize',
    color: (props) => props.colors.textBody,
  },
  avatar: {
    height: 32,
    width: 32,
    backgroundColor: (props) => props.colors.colorBackground,
    marginRight: 10,
    border: `1px solid ${(props) => props.colors.accentColor}`,
  },
  menuItem: {
    minHeight: 42,
    color: '#676767',
    minWidth: 236,
    backgroundColor: (props) => props.colors.colorBackground,
    '&:hover': {
      background: (props) => props.colors.colorBackground,
    },
  },
  textMenuItem: {
    fontSize: theme.typography.pxToRem(14),
    marginLeft: 10,
    fontFamily: 'Roboto',
    fontWeight: 500,
    color: (props) => props.colors.textBody,
  },
  textCpf: {
    fontSize: theme.typography.pxToRem(10),
    fontWeight: 400,
    textAlign: 'start',
    fontFamily: 'Roboto',
    color: (props) => props.colors.accentColor,
  },
  textCpfPopOver: {
    fontSize: theme.typography.pxToRem(10),
    fontWeight: 400,
    textAlign: 'start',
    fontFamily: 'Roboto',
    color: (props) => props.colors.textBody,
  },
  buttonAccessibility: {
    display: 'inline-block',
    padding: 6,
    minWidth: 0,
    minHeight: 0,
    fontSize: 14,
    justifyContent: 'center',
    alignItems: 'center',
    color: (props) => props.colors.accentColor,
  },
  boxAccessibility: {
    display: 'flex',
    alignItems: 'center',
    width: 30,
    justifyContent: 'center',
    height: 30,
    borderRadius: '50%',
    backgroundColor: (props) => props.colors.accentColor,
    marginRight: 8,
    padding: 0,
  },
  boxSubMenu: {
    height: 32,
    width: '100%',
    display: 'flex',
    backgroundColor: (props) => props.colors.accentColorBackground,
  },
  boxSub: {
    width: '1050px',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  linksBoxSubMenu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 7,
    minWidth: 742.93,
  },
  textLocale: {
    display: 'flex',
    alignItems: 'center',
    padding: '3px 15px',
    fontSize: theme.typography.pxToRem(12),
    fontFamily: 'Roboto',
    fontWeight: 500,
    color: '#3E3E3E',
    borderLeft: '1px solid #DBDFE2',
    borderRight: '1px solid #DBDFE2',
  },
  textFontContrast: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    color: (props) => props.colors.textBody,
  },
  boxInfo: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    color: (props) => props.colors.accentColor,
  },
  btnSocial: {
    color: (props) => props.colors.textAccentColor,
    padding: 0,
    margin: '0 10px',
  },
  boxIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    alignItems: 'center',
  },
  iconSocial: {
    width: 18,
    height: 18,
  },
  boxLogin: {
    width: 'auto',
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    padding: '0 12px',
    borderRadius: 15,
    backgroundColor: (props) => props.colors.searchInputColor,
    '&:hover': {
      backgroundColor: (props) => props.colors.breadcrumbButtonColorHover,
    },
  },
  textLink: {
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    textAlign: 'center',
    textDecoration: 'none',
    color: (props) => props.colors.textAccentColor,
    textTransform: 'uppercase',
  },
  loginIcon: {
    height: 25,
    width: 25,
    color: (props) => props.colors.colorSecondary,
  },
  divider: {
    color: (props) => props.colors.accentColor,
    margin: '0px 10px',
  },
  dividerWhite: {
    color: '#fff',
    margin: '0px 10px',
  },
  navBar: {
    width: '100%',
    height: 83,
    backgroundColor: (props) => props.colors.colorBackgroundSecundary,
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  navBarLinks: {
    width: '100%',
    display: 'flex',
    maxWidth: '1320px',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  linksBox: {
    display: 'flex',
    gap: 30,
  },
  links: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 700,
    color: (props) => props.colors.accentColor,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: '#fff',
    },
  },
  iconNavBar: {
    marginRight: 10,
  },
  img: {
    maxWidth: 513,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 247,
      height: 'auto',
    },
  },
  boxRadio: {
    color: '#FFFFFF',
    width: '100%',
    height: 28,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonPlay: {
    width: 40,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#442771',
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    padding: 11,
    cursor: 'pointer',
  },
  textTitleRadio: {
    color: '#FFFFFF',
    fontSize: theme.typography.pxToRem(8),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '0.9',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  textSubTitleRadio: {
    color: '#FFFFFF',
    fontSize: theme.typography.pxToRem(10),
    fontStyle: 'normal',
    fontWeight: 400,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  buttonDrop: {
    padding: '0px !important',
    '&:focus': {
      boxShadow: 'unset !important',
    },
  },
  dropItem: {
    width: 'fit-content',
  },
  slugLinks: {
    textDecoration: 'none',
    color: 'inherit',
  },
  dropdown: {
    position: 'absolute',
    top: 67,
    left: 0,
    width: '100%',
    minHeight: '300px',
    backgroundColor: '#fff',
    zIndex: 5,
  },
  listUl: {
    display: 'flex',
    justifyContent: 'center',
    // backgroundColor: '#ccc',
  },
  listLi: {
    padding: 5,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  infoHeaderRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  navigationMobile: {
    padding: '0px 20px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  iconQuickAccess: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  drawerActions: {
    top: 224,
    height: 'calc(100vh - 215px)',
    backgroundColor: (props) => props.colors.colorBackgroundSecundary,
  },
  titleDrawer: {
    margin: '24px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textDrawer: {
    fontFamily: 'Roboto',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  accordionRoot: {
    backgroundColor: (props) => props.colors.colorBackgroundSecundary,
    border: 'none',
    padding: '0px 20px',
  },
  listDrawer: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    color: (props) => props.colors.textAccentColor,
    marginLeft: 10,
  },
  listAcordeons: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  accordion: {
    '&.MuiAccordion-root:before': {
      backgroundColor: 'transparent',
    },
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
  linksMobile: {
    textDecoration: 'none',
    marginLeft: 8,
    color: (props) => props.colors.textBody,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    fontFamily: 'Roboto',
  },
  player: {
    display: 'none',
  },
}))
